(function(){
'use strict';

/* ============================================================
   CONFIG
   ============================================================ */
var STAGE_EL    = document.getElementById("stage");
var VIDEO_URL   = (STAGE_EL && STAGE_EL.dataset.video)  || "assets/hero-scrub.mp4";
var POSTER_URL  = (STAGE_EL && STAGE_EL.dataset.poster) || "assets/hero-poster.jpg";
var ENDING_URL  = (STAGE_EL && STAGE_EL.dataset.ending) || "assets/hero-ending.jpg";
var VIDEO_BYTES_ATTR = STAGE_EL && Number(STAGE_EL.dataset.bytes);
var VIDEO_BYTES = VIDEO_BYTES_ATTR || 4032910;
var CONTACT_EMAIL = 'contactstudiocorporate@gmail.com';
/* No Klaviyo on the page, on purpose. Their /client/events/ endpoint refuses browser
   calls (its CORS preflight allows only OPTIONS, verified twice from studiocorporate.fr),
   and their on-site library pulls eleven scripts and sets tracking identifiers. On a
   68 KB French site with no cookie banner, that is the wrong trade for a handful of
   leads a month. The quote request still reaches the studio by email through Shopify. */   /* found on the studio's own Shopify, Gmail, Calendar and Signeasy accounts */

var hero    = document.getElementById('hero');
var stage   = document.getElementById('stage');
var video   = document.getElementById('hero-video');
var poster  = document.getElementById('poster');
var ring    = document.getElementById('ring');
var cue     = document.getElementById('cue');
var navEl   = document.getElementById('nav');

/* The same script ships inside the Shopify theme, where it also runs on pages that
   have no hero (a product, a policy page, the 404). Everything hero-shaped is gated
   on this one flag. On the static build it is always true. */
var HAS_HERO = !!(hero && stage && video);

/* The phone's Accueil page replaces this hero entirely, so painting it there would
   fetch two images nobody sees. Paint it only when the page is not in paged mode,
   and paint it on the way out of paged mode, which is what leavePaged() calls. */
function paintStaticHero(){
  if (!HAS_HERO) return;
  var el = document.getElementById('static-hero');
  if (!el || el.style.backgroundImage) return;
  el.style.backgroundImage = "url('" + ENDING_URL + "'), url('" + POSTER_URL + "')";
}
if (!(matchMedia('(max-width: 820px)').matches &&
      !matchMedia('(orientation: landscape) and (max-height: 520px)').matches)){
  paintStaticHero();
}

/* ============================================================
   THE FIVE STATIC-HERO GATES
   Character-for-character identical to the CSS media query above.
   ============================================================ */
var GATES = [
  '(max-width: 720px)',
  '(orientation: portrait) and (max-width: 1024px)',
  '(orientation: portrait) and (pointer: coarse)',
  '(orientation: landscape) and (pointer: coarse) and (max-height: 560px)',
  '(prefers-reduced-motion: reduce)'
];
var MQLS = GATES.map(function(q){ return matchMedia(q); });

function rng(seed){
  var s = seed >>> 0;
  return function(){ s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; };
}
function clamp(v, lo, hi){ return Math.min(hi, Math.max(lo, v)); }
function smoothstep(p, e0, e1){
  var t = clamp((p - e0) / (e1 - e0), 0, 1);
  return t * t * (3 - 2 * t);
}

/* ============================================================
   TEXT SPLITTING (once, at load)
   ============================================================ */
(function splitAll(){
  var nodes = document.querySelectorAll('.split');
  for (var n = 0; n < nodes.length; n++){
    var el = nodes[n];
    var text = el.textContent.trim();
    var mode = el.getAttribute('data-mode') || 'word';
    var spread = parseFloat(el.getAttribute('data-spread') || '0.34');
    var emWord = el.getAttribute('data-em');
    var rand = rng(1337 + n * 97);

    el.textContent = '';
    var sr = document.createElement('span');
    sr.className = 'sr';
    sr.textContent = text;
    el.appendChild(sr);

    var vis = document.createElement('span');
    vis.setAttribute('aria-hidden', 'true');

    if (mode === 'none'){
      var stack = document.createElement('span');
      stack.className = 'stack';
      var soft = document.createElement('span');
      soft.className = 'soft'; soft.textContent = text;
      var sharp = document.createElement('span');
      sharp.className = 'sharp'; sharp.textContent = text;
      stack.appendChild(soft); stack.appendChild(sharp);
      vis.appendChild(stack);
      el.appendChild(vis);
      continue;
    }

    var words = text.split(' ');
    for (var i = 0; i < words.length; i++){
      var w = document.createElement('span');
      w.className = 'w';
      if (emWord && words[i].toLowerCase().indexOf(emWord) === 0) w.className += ' em';
      w.textContent = words[i] + (i < words.length - 1 ? ' ' : '');
      var th = (i / Math.max(1, words.length - 1)) * spread + rand() * 0.05;
      w.style.setProperty('--th', th.toFixed(3));
      vis.appendChild(w);
    }
    el.appendChild(vis);
  }
})();

/* ============================================================
   BANDS
   ============================================================ */
var bands = [].slice.call(document.querySelectorAll('.band')).map(function(el){
  var r = (el.getAttribute('data-range') || '0,1').split(',');
  return { el: el, a: parseFloat(r[0]), b: parseFloat(r[1]),
           ramp: parseFloat(el.getAttribute('data-ramp') || '0'), op: -1, k: -1 };
});

var loadK = 0, loadStart = 0;

function updateCaptions(p){
  for (var i = 0; i < bands.length; i++){
    var B = bands[i];
    var f = Math.min(0.02, (B.b - B.a) / 3);
    var inA = (i === 0) ? 1 : smoothstep(p, B.a, B.a + f);
    var outB = (i === bands.length - 1) ? 0 : smoothstep(p, B.b - f, B.b);
    var op = inA * (1 - outB);

    var k = clamp((p - B.a) / (B.ramp || Math.min(0.025, (B.b - B.a) * 0.35)), 0, 1);
    if (i === 0) k = Math.max(k, loadK);

    if (Math.abs(op - B.op) > 0.004){ B.op = op; B.el.style.opacity = op.toFixed(3); }
    if (Math.abs(k - B.k) > 0.008){ B.k = k; B.el.style.setProperty('--k', k.toFixed(3)); }
  }
}

/* ============================================================
   SEEK GATING (deadlock-safe)
   ============================================================ */
var seekBusy = false, pendingTime = null;
function requestSeek(t){
  if (!video.duration) return;
  if (seekBusy){ pendingTime = t; return; }
  seekBusy = true;
  try { video.currentTime = t; } catch(e){ seekBusy = false; }
}
if (HAS_HERO){
video.addEventListener('seeked', function(){
  seekBusy = false;
  if (pendingTime !== null){ var t = pendingTime; pendingTime = null; requestSeek(t); }
});
video.addEventListener('error', function(){ seekBusy = false; pendingTime = null; failVideo(); });
}

/* ============================================================
   THE DRIVE LOOP
   ============================================================ */
var target = 0, shown = 0, rafId = null, lastTick = 0, heroOnScreen = true;

function heroProgress(){
  if (!HAS_HERO) return 0;
  var r = hero.getBoundingClientRect();
  var range = hero.offsetHeight - window.innerHeight;
  if (range <= 0) return 0;
  return clamp(-r.top / range, 0, 1);
}
/* the rect is the source of truth; the observer is only an optimisation.
   Relying on the observer alone left the bands stale when the hero was
   re-entered from below, because the loop never restarted. */
function heroVisible(){
  var r = hero.getBoundingClientRect();
  return r.bottom > -40 && r.top < window.innerHeight + 40;
}

function tick(now){
  var dt = Math.min(100, now - (lastTick || now));
  lastTick = now;
  var k = 0.16;
  shown += (target - shown) * (1 - Math.pow(1 - k, dt / 16.667));

  if (loadStart && loadK < 1) loadK = clamp((now - loadStart) / 900, 0, 1);

  if (Math.abs(target - shown) < 0.0005 && loadK >= 1){
    shown = target; rafId = null; lastTick = 0;
  } else {
    rafId = requestAnimationFrame(tick);
  }
  if (video.duration) requestSeek(shown * video.duration);
  updateCaptions(shown);
}

function onScroll(){
  if (!HAS_HERO) return;
  target = heroProgress();
  heroOnScreen = heroVisible();
  if (target > 0.02) retireCue();
  if (rafId === null && heroOnScreen) rafId = requestAnimationFrame(tick);
}

if (HAS_HERO && 'IntersectionObserver' in window){
  new IntersectionObserver(function(es){
    heroOnScreen = es[0].isIntersecting;
    if (heroOnScreen && rafId === null && scrubOn){
      target = heroProgress();
      rafId = requestAnimationFrame(tick);
    }
  }, { rootMargin: '40px' }).observe(hero);
}

/* ============================================================
   THE BLOB LOADER
   ============================================================ */
var heroInit = false;
function initHeroOnce(){
  if (heroInit) return;
  heroInit = true;
  loadStart = performance.now();

  poster.style.backgroundImage = "url('" + POSTER_URL + "')";
  var started = false;
  function startBlobFetch(){
    if (started) return;
    started = true;
    loadHeroBlob().catch(failVideo);
  }
  var pi = new Image();
  pi.onload = function(){ poster.classList.add('on'); startBlobFetch(); };
  pi.onerror = startBlobFetch;
  pi.src = POSTER_URL;
  setTimeout(startBlobFetch, 4000);
}

function loadHeroBlob(){
  var ctrl = new AbortController();
  var watchdog = setTimeout(function(){ ctrl.abort(); }, 20000);

  return fetch(VIDEO_URL, { signal: ctrl.signal }).then(function(res){
    if (!res.ok || !res.body) throw new Error('no video');
    var total = Number(res.headers.get('Content-Length')) || VIDEO_BYTES;
    var reader = res.body.getReader();
    var chunks = [], got = 0, lastRing = 0;

    function pump(){
      return reader.read().then(function(r){
        if (r.done){
          clearTimeout(watchdog);
          ring.style.setProperty('--ld', 0);
          ring.classList.add('done');
          video.src = URL.createObjectURL(new Blob(chunks, { type: 'video/mp4' }));
          video.load();
          video.addEventListener('canplay', function(){
            requestSeek(heroProgress() * video.duration);
            stage.classList.add('video-ready');
            showCue();          /* an invitation to scroll, once there is something to scroll */
          }, { once: true });
          return;
        }
        clearTimeout(watchdog);
        watchdog = setTimeout(function(){ ctrl.abort(); }, 20000);
        chunks.push(r.value);
        got += r.value.length;
        var frac = Math.min(1, got / total);
        var now = performance.now();
        if (now - lastRing > 100 || frac === 1){
          lastRing = now;
          ring.style.setProperty('--ld', Math.round(126 * (1 - frac)));
        }
        return pump();
      });
    }
    return pump();
  });
}

var cueShown = false;
function showCue(){
  if (!cue || cueShown) return;
  cue.hidden = false;
  cueShown = true;
  requestAnimationFrame(function(){ cue.classList.add('on'); });
}
function retireCue(){
  if (!cueShown) return;
  cueShown = false;
  cue.classList.remove('on');   /* it did its job the moment they scrolled */
}
function failVideo(){
  ring.classList.add('done');
  showCue();                    /* the page is complete over the poster; the cue still helps */
  stage.classList.add('video-failed');
}

/* ============================================================
   ARM AND DISARM THE SCRUB, live on every gate change
   ============================================================ */
var scrubOn = false;

function enableScrub(){
  if (scrubOn) return;
  scrubOn = true;
  initHeroOnce();
  window.addEventListener('scroll', onScroll, { passive: true });
  for (var i = 0; i < bands.length; i++){ bands[i].op = -1; bands[i].k = -1; }
  unpinFinalStates();
  target = shown = heroProgress();
  updateCaptions(shown);
  onScroll();
}
function disableScrub(){
  if (!scrubOn) return;
  scrubOn = false;
  window.removeEventListener('scroll', onScroll);
  if (rafId !== null){ cancelAnimationFrame(rafId); rafId = null; }
}
function applyHeroMode(){
  if (!HAS_HERO) return;
  var hit = false;
  for (var i = 0; i < MQLS.length; i++){ if (MQLS[i].matches){ hit = true; break; } }
  if (hit) disableScrub(); else enableScrub();
}
MQLS.forEach(function(m){
  if (m.addEventListener) m.addEventListener('change', applyHeroMode);
  else if (m.addListener) m.addListener(applyHeroMode);
});

/* ============================================================
   THE PAGE AROUND THE HERO
   ============================================================ */
var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
  es.forEach(function(e){
    if (!e.isIntersecting) return;
    e.target.classList.add('in');
    if (e.target.classList.contains('stagger')){
      setTimeout(function(){ e.target.classList.add('done'); }, 1500);
    }
    io.unobserve(e.target);
  });
}, { rootMargin: '0px 0px -12% 0px' }) : null;

if (io){
  [].slice.call(document.querySelectorAll('.rise,.stagger')).forEach(function(el){ io.observe(el); });
} else {
  [].slice.call(document.querySelectorAll('.rise,.stagger')).forEach(function(el){ el.classList.add('in','done'); });
}

var navSolid = false;
function navCheck(){
  if (!navEl) return;
  /* No hero on this page (an interior Shopify page, or a phone page other than
     Accueil): the masthead sits on the light canvas, so it is solid straight away. */
  var heroLive = HAS_HERO && hero.offsetHeight > 0;
  var s = heroLive ? window.scrollY > (hero.offsetHeight - window.innerHeight * 0.85) : true;
  if (s === navSolid) return;
  navSolid = s;
  navEl.classList.toggle('solid', s);
  if (hero) hero.classList.toggle('on-dark', !s);
}

var pageTicking = false;
window.addEventListener('scroll', function(){
  if (pageTicking) return;
  pageTicking = true;
  requestAnimationFrame(function(){ navCheck(); pageTicking = false; });
}, { passive: true });
navCheck();

/* ============================================================
   THE ONE INTERACTIVE MOMENT: press and hold to open the aperture
   ============================================================ */
(function(){
  var stageEl = document.getElementById('irisStage');
  var btn = document.getElementById('holdBtn');
  var exif = document.getElementById('exif');
  var lines = document.getElementById('openLines');
  if (!stageEl || !btn) return;

  var STOPS = ['f/22','f/16','f/11','f/8','f/5.6','f/4','f/2.8','f/2'];
  var open = 0, holding = false, hraf = null, hlast = 0;
  var lastExif = '', lastExifAt = 0;

  function write(v){
    var s = v.toFixed(3);
    stageEl.style.setProperty('--open', s);
    btn.style.setProperty('--open', s);
    lines.style.setProperty('--open', s);
  }
  function paint(now){
    var dt = Math.min(100, now - (hlast || now));
    hlast = now;
    var goal = holding ? 1 : 0;
    var rate = holding ? 0.055 : 0.040;
    open += (goal - open) * (1 - Math.pow(1 - rate, dt / 16.667));

    if (Math.abs(goal - open) < 0.002){ open = goal; hraf = null; hlast = 0; }
    else hraf = requestAnimationFrame(paint);

    write(open);
    var label = STOPS[Math.min(STOPS.length - 1, Math.floor(open * STOPS.length))];
    if (now - lastExifAt > 100 && label !== lastExif){
      lastExif = label; lastExifAt = now; exif.textContent = label;
    }
  }
  function drive(){ if (hraf === null) hraf = requestAnimationFrame(paint); }
  function start(e){ if (e && e.cancelable) e.preventDefault(); holding = true; drive(); }
  function stop(){ holding = false; drive(); }

  btn.addEventListener('pointerdown', start);
  window.addEventListener('pointerup', stop);
  window.addEventListener('pointercancel', stop);
  btn.addEventListener('keydown', function(e){
    if (e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); if (!holding) start(); }
  });
  btn.addEventListener('keyup', function(e){
    if (e.key === ' ' || e.key === 'Enter') stop();
  });

  var rmq = matchMedia('(prefers-reduced-motion: reduce)');
  function rmIris(){
    if (!rmq.matches) return;
    holding = false;
    if (hraf !== null){ cancelAnimationFrame(hraf); hraf = null; }
    open = 1; write(1); exif.textContent = 'f/2';
  }
  rmIris();
  rmq.addEventListener('change', rmIris);
})();

/* ============================================================
   REDUCED MOTION, live, in BOTH directions
   ============================================================ */
function pinToFinalStates(){
  [].slice.call(document.querySelectorAll('.rise,.stagger')).forEach(function(el){
    el.classList.add('in','done','pinned');
  });
  if (rafId !== null){ cancelAnimationFrame(rafId); rafId = null; }
}
function unpinFinalStates(){
  [].slice.call(document.querySelectorAll('.pinned')).forEach(function(el){
    el.classList.remove('pinned');
  });
}
matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', function(e){
  if (e.matches) pinToFinalStates();
  else applyHeroMode();
});

document.addEventListener('visibilitychange', function(){
  document.body.classList.toggle('paused', document.hidden);
});

/* ============================================================
   THE FORM
   ============================================================ */
(function(){
  /* Shopify renders the id we pass to {% form %}, but not depending on it is cheaper
     than trusting it: the contact form is also findable by where it posts. */
  var form = document.getElementById('devisForm') || document.querySelector('form[action*="/contact"]');
  var ok = document.getElementById('okBox');
  var note = document.getElementById('formNote');
  if (!form) return;

  /* On Shopify the form posts to the store's own contact endpoint and the browser must
     be left alone to submit it. Shopify's form tag always writes this hidden input, so
     it is the honest marker. The mailto path below belongs to the static build only. */
  if (form.querySelector('input[name="form_type"]')){
    if (note) note.textContent = "Votre demande arrive directement dans la boîte mail du studio.";
    return;
  }

  if (CONTACT_EMAIL){
    note.textContent = "Votre message ouvre votre logiciel de messagerie, adressé au studio.";
  } else {
    note.textContent = "Le formulaire n'est pas encore relié à une boîte mail. Donnez-nous l'adresse du studio et il part en une minute.";
    note.className = 'form-note todo';
  }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    if (!form.checkValidity()){ form.reportValidity(); return; }
    if (!CONTACT_EMAIL){
      note.textContent = "Envoi impossible pour l'instant : aucune adresse de destination n'est configurée.";
      return;
    }
    var d = new FormData(form);
    var body = [
      'Nom : ' + (d.get('nom') || ''),
      'Entreprise : ' + (d.get('entreprise') || ''),
      'Email : ' + (d.get('email') || ''),
      'Téléphone : ' + (d.get('telephone') || ''),
      'Besoin : ' + (d.get('type') || ''),
      'Date : ' + (d.get('date') || 'non précisée'),
      '',
      (d.get('message') || '')
    ].join('\n');

    window.location.href = 'mailto:' + CONTACT_EMAIL +
      '?subject=' + encodeURIComponent('Demande de devis : ' + (d.get('entreprise') || d.get('nom') || '')) +
      '&body=' + encodeURIComponent(body);

    form.style.display = 'none';
    ok.classList.add('on');
  });
})();

applyHeroMode();

/* ============================================================
   THE PAGED PHONE LAYOUT
   On a phone the site stops being one 14,000px scroll and becomes five short pages.
   Desktop never enters this mode. The gate is live, so rotating a phone or resizing
   a window moves between the two layouts without a reload.
   ============================================================ */
(function(){
  var PAGED_Q  = '(max-width: 820px)';
  var FLAT_Q   = '(orientation: landscape) and (max-height: 520px)';  /* sideways: no room for a bar */
  var tabbar   = document.getElementById('tabbar');
  if (!tabbar) return;
  var reduce   = matchMedia('(prefers-reduced-motion: reduce)');

  var tabs  = [].slice.call(tabbar.querySelectorAll('button[data-go]'));
  var parts = [].slice.call(document.querySelectorAll('[data-page]'));
  var pages = tabs.map(function(t){ return t.getAttribute('data-go'); });
  var current = null;
  var paged = false;

  /* which page holds a given element, so an anchor can carry the visitor to it */
  function pageOf(el){
    var host = el && el.closest ? el.closest('[data-page]') : null;
    return host ? host.getAttribute('data-page') : null;
  }

  function show(page, opts){
    if (!paged) return;
    if (pages.indexOf(page) === -1) page = pages[0];
    var changed = page !== current;
    current = page;
    parts.forEach(function(el){
      var on = el.getAttribute('data-page') === page;
      el.classList.toggle('pg-off', !on);
      /* keep hidden pages out of the tab order and away from screen readers */
      if ('inert' in el) el.inert = !on;
      else el.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    tabs.forEach(function(t){
      t.setAttribute('aria-selected', t.getAttribute('data-go') === page ? 'true' : 'false');
    });
    document.body.setAttribute('data-page', page);   /* a hook for per-page styling */
    if (changed && !(opts && opts.keepScroll)){
      window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    navCheck();
  }

  function enterPaged(){
    if (paged) return;
    paged = true;
    document.body.classList.add('paged');
    var fromHash = location.hash ? pageOf(document.querySelector(location.hash)) : null;
    show(fromHash || pages[0], { keepScroll: true });
  }

  function leavePaged(){
    if (!paged) return;
    paged = false;
    current = null;
    document.body.classList.remove('paged');
    document.body.removeAttribute('data-page');
    paintStaticHero();          /* the hero is on screen again and needs its backdrop */
    parts.forEach(function(el){
      el.classList.remove('pg-off');
      if ('inert' in el) el.inert = false; else el.removeAttribute('aria-hidden');
    });
    navCheck();
  }

  tabs.forEach(function(t){
    t.addEventListener('click', function(){ show(t.getAttribute('data-go')); });
  });

  /* Every in-page link has to change page first, or it scrolls to something hidden.
     Bound once on the document so links added later keep working. */
  document.addEventListener('click', function(e){
    if (!paged) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    /* Same-page links come in three spellings: "#devis" in the static build, "/#devis"
       in the Shopify theme, and the full path plus fragment. All three must switch page,
       or a visitor taps Réserver and nothing happens. */
    var href = a.getAttribute('href') || '';
    var cut  = href.indexOf('#');
    if (cut < 0) return;
    var path = href.slice(0, cut);
    var id   = href.slice(cut);
    if (path && path !== '/' && path !== location.pathname) return;
    if (id === '#') return;
    var target = document.querySelector(id);
    if (!target) return;
    var page = pageOf(target);
    if (!page) return;
    e.preventDefault();
    if (page !== current){
      show(page, { keepScroll: true });
      /* let the layout settle before measuring where the target landed */
      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
        });
      });
    } else {
      target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
    }
  });

  var mqPaged = matchMedia(PAGED_Q);
  var mqFlat  = matchMedia(FLAT_Q);
  function applyPaging(){
    if (mqPaged.matches && !mqFlat.matches) enterPaged();
    else leavePaged();
  }
  [mqPaged, mqFlat].forEach(function(m){
    if (m.addEventListener) m.addEventListener('change', applyPaging);
    else if (m.addListener) m.addListener(applyPaging);
  });
  applyPaging();
})();

})();
